import { render, staticRenderFns } from "./Sale.vue?vue&type=template&id=91f04418&scoped=true"
import script from "./Sale.vue?vue&type=script&lang=js"
export * from "./Sale.vue?vue&type=script&lang=js"
import style0 from "./Sale.vue?vue&type=style&index=0&id=91f04418&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91f04418",
  null
  
)

export default component.exports